import { assign, setup } from 'xstate';
import { showAxiosErrorAction } from '~/features/actions';
import { CERTIFICATION_CRUD_STATE } from '~/features/xstateSystem';
import { createBaseCrudMachine } from '~/machines/base-crud';
import { Certification } from '~/types/mcv/certification';
import {
  openConfirmation,
  sendContextToCrud,
  sendLoadToCrud,
  setIssuersOption,
  setProviderData,
} from './actions';
import { API_CALLS } from './api';
import { emptyCertForm, ISSUER_OPTIONS } from './constants';
import { CertMachineEvents as Events } from './events';
import { CertFormValues, CertSort, CertContext as Context } from './types';

export const tableMachine = createBaseCrudMachine<Certification, CertFormValues, CertSort>({
  initialForm: emptyCertForm,
  sort: {
    sortBy: 'id',
    cert_name: -1,
    active_flag: -1,
    cert_num: -1,
    expiry_date: -1,
    issue_date: -1,
    issuer: -1,
    id: 1,
    page: 1,
    pageSize: 10,
  },
  apiCalls: API_CALLS,
});

export const certMachine = setup({
  actors: {
    crudRef: tableMachine,
  },
  actions: {
    sendContextToCrud: sendContextToCrud,
    sendLoadToCrud: sendLoadToCrud,
    setProviderData: assign(setProviderData),
    setIssuerOption: assign(setIssuersOption),
    sendError: showAxiosErrorAction,
    sendDeleteConfirmation: openConfirmation,
  },
  types: {
    context: {} as Context,
    events: {} as Events,
    input: {} as Partial<Context>,
  },
}).createMachine({
  context: ({ spawn }) => ({
    crudRef: spawn('crudRef', {
      id: CERTIFICATION_CRUD_STATE,
      input: { data: [] },
    }),
    boardCerts: [],
    idsToDelete: [],
    providerId: -1,
    providerCategoryId: -1,
    loading: false,
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
    },
    issuerOptions: ISSUER_OPTIONS,
  }),
  initial: '$_IDLE',
  states: {
    $_IDLE: {
      on: {
        ON_SEND_SHARED_CONTEXT: {
          actions: ['setProviderData', 'sendContextToCrud'],
        },
        ON_LOAD: {
          actions: ['sendLoadToCrud'],
        },
        ON_CERTNAME_SELECT: {
          actions: ['setIssuerOption'],
        },
        ON_SEND_DELETE_CONFIRMATION: {
          actions: ['sendDeleteConfirmation'],
        },
      },
    },
  },
});
